import React, { useCallback } from 'react'

import { Duplicate } from '@surglogs-app/icons'
import { Button } from '@surglogs-app/ui'

import { copyToClipboard } from '../utils/copyToClipboard'

interface CopyButtonProps {
  value: string
}

export const CopyButton = ({ value }: CopyButtonProps) => {
  const onClick = useCallback(() => {
    copyToClipboard(value)
  }, [value])

  return (
    <Button {...{ variant: 'secondary', icon: Duplicate, ml: 'md', onClick }} />
  )
}
